// src/services/tagService.js
import api from './api';

export function fetchTags() {
  return api.get('/tags');
}

export function getTagById(id) {
  return api.get(`/tags/${id}`);
}

export function createTag(data) {
  return api.post('/tags', data);
}

export function updateTag(data) {
  return api.put(`/tags/${data.tagId}`, data);
}

export function deleteTag(id) {
  return api.delete(`/tags/${id}`);
}

export function deleteTagsBatch(ids) {
  return api.delete('/tags', { data: ids }); // importante: usar 'data' no DELETE
}

export async function fetchTagsPaged(pageNumber, pageSize, search = '') {
  return api.get('/tags/paged', {
    params: {
      pageNumber,
      pageSize,
      search
    }
  });
}